import { agendaMagasinTunnelMock, bandeauBeneficesMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [bandeauBeneficesMock, agendaMagasinTunnelMock];

export const tunnelStep2Mock: SlugPage = {
  ...pageBase({
    title: 'Tunnel RDV - Etape 2',
    type: 'tunnel',
    language: 'fr-FR',
    headerId: 'tunnel-fr',
    footerId: '',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
